import { unref } from 'vue';

import type { MaybeRefOrGetter } from '../';

type AnyFn = (...args: any[]) => any;

/**
 * Get the value of value/ref/getter.
 */
export function toValue<T>(r: MaybeRefOrGetter<T>): T {
  return typeof r === 'function' ? (r as AnyFn)() : unref(r);
}
